import { useEffect, useState } from "react";
import Hero from "./components/Hero";
import StorySection from "./components/StorySection";
import EpisodePreview from "./components/EpisodePreview";
import CharacterPreview from "./components/CharacterPreview";
import CompareSection from "./components/CompareSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";
import AnimeNavbar from "@/components/feature/AnimeNavbar";
import AnimeFooter from "@/components/feature/AnimeFooter";
import { faqs, siteName } from "@/mocks/anime";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 cursor-pointer ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

function SeoScript() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: siteName,
        url: "https://mysteryplot.github.io/",
      },
      {
        "@type": "WebPage",
        name: "秘密教学动漫剧情、分集介绍、角色与结局全解析",
        url: "https://mysteryplot.github.io/",
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />;
}

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SeoScript />
      <AnimeNavbar />
      <main className="flex-1">
        <Hero />
        <StorySection />
        <EpisodePreview />
        <CharacterPreview />
        <CompareSection />
        <FaqSection />
        <ContactSection />
      </main>
      <AnimeFooter />
      <BackToTop />
    </div>
  );
}